var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ykCopy" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.text
        ? _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                effect: "light",
                content: "点击复制" + _vm.type,
                placement: "top",
              },
            },
            [
              _c("i", {
                directives: [
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: _vm.text,
                    expression: "text",
                    arg: "copy",
                  },
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:success",
                    value: _vm.handleCopy,
                    expression: "handleCopy",
                    arg: "success",
                  },
                ],
                staticClass: "el-icon-document-copy",
                staticStyle: { cursor: "pointer" },
              }),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }